import { useFormContext, useIsSubmitting, useIsValid } from 'remix-validated-form'
import { Button } from '~/components/shared'
import type { ButtonProps } from '~/components/shared/Button'
import WarningBox from '../../WarningBox'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

type SubmitButtonProps = {
  label: string
  class?: string
  warning?: boolean
  buttonProps?: ButtonProps
}

export default function SubmitButton(props: SubmitButtonProps) {
  const isSubmitting = useIsSubmitting()
  const form = useFormContext()
  const isValid = useIsValid()
  const { t } = useTranslation()
  const missingSelections = t('required_selections_missing', { ns: 'ui' })
  const { buttonProps } = props


  // https://thetradingpit.atlassian.net/browse/DV-3397
  // workaround to disable the loading state
  const [isRestoredFromCache, setIsRestoredFromCache] = useState({
    cache: false,
    submitted: false
  })

  useEffect(() => {
    const ac = new AbortController()
    window.addEventListener('pageshow', event => {
      // the page was restored from the browser's cache
      if (event.persisted) {
        setIsRestoredFromCache({
          cache: true,
          submitted: false
        })
      }
    }, { signal: ac.signal })

    return () => ac.abort()
  }, [])
  // -----

  const isLoading = isRestoredFromCache.cache ?
    isRestoredFromCache.submitted
    : isSubmitting


  return (
    <>
      <Button
        type="submit"
        disabled={isLoading}
        className={props.class}
        loading={isLoading}
        onClick={() => {
          // if the page is restored from the cache take control over loading state
          if (isRestoredFromCache.cache) {
            setIsRestoredFromCache({
              cache: true,
              submitted: true
            })
            form.submit()
          }
        }}
        {...buttonProps}
      >
        {props.label}
      </Button>
      {props.warning && !isValid && (
        <div className="mt-2">
          <WarningBox message={missingSelections} />
        </div>
      )}
    </>
  )
}
